import { render, staticRenderFns } from "./VContractStats.vue?vue&type=template&id=011f1dd9&"
import script from "./VContractStats.vue?vue&type=script&lang=js&"
export * from "./VContractStats.vue?vue&type=script&lang=js&"
import style0 from "./VContractStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports